module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_5.c9d1bc98.png";